export const en = {
  'calls-history-title': 'Calls history',
  'collect-call': 'Collect call',
  'stub-description': 'A list of your past calls will be displayed here',
  'stub-title': 'You don\'t have any calls',
  'stub-title-with-records': 'You don\'t have any calls with records'
}
